import { useEffect } from 'react';

// RecordsHOC renders the table outside each page's toolbar container, so the
// redesign uses a body class to scope shared table chrome. Refcounting keeps
// route transitions and StrictMode cleanup from removing the class while
// another redesigned Records page is still mounted.
const REDESIGN_BODY_CLASS = 'records-redesign-enabled';
let mountedCount = 0;

export const acquireRecordsRedesignBodyClass = () => {
  mountedCount += 1;
  if (mountedCount === 1) document.body.classList.add(REDESIGN_BODY_CLASS);
};

export const releaseRecordsRedesignBodyClass = () => {
  mountedCount -= 1;
  if (mountedCount <= 0) {
    mountedCount = 0;
    document.body.classList.remove(REDESIGN_BODY_CLASS);
  }
};

const useRecordsRedesignBodyClass = () => {
  useEffect(() => {
    acquireRecordsRedesignBodyClass();
    return releaseRecordsRedesignBodyClass;
  }, []);
};

export default useRecordsRedesignBodyClass;
